import * as R from 'ramda';
import React from 'react';
// components
import { EmptyList } from '../../../../../components/list';
import { LoadStatusActions } from '../../../../../components/load-status-actions';
// helpers/constants
import * as G from '../../../../../helpers';
import * as GC from '../../../../../constants';
// icons
import * as I from '../../../../../svgs';
// ui
import { Box, Flex } from '../../../../../ui';
// feature configurations
import { ConfigGroupLeftSectionWrapper } from '../../../ui';
//////////////////////////////////////////////////

const DispatchPanelConfig = (props) => {
  const {
    loadType,
    cloPanel,
    telPanel,
    configName,
    handleEditEntity,
    centralizedDispatchActionPanel,
    deleteDispatchBoardStatusActionRequest,
  } = props;

  const configNameToUse = R.or(configName, loadType);

  const isCentralizedDispatchActions = R.equals(
    configNameToUse,
    GC.FIELD_CONFIGURATION_UI_CENTRALIZED_DISPATCH_ACTIONS,
  );

  const panel = G.ifElse(
    isCentralizedDispatchActions,
    centralizedDispatchActionPanel,
    G.ifElse(R.equals(loadType, GC.LOAD_TYPE_TEL), telPanel, cloPanel),
  );

  const iconColor = G.getTheme('icons.iconColor');

  return (
    <Box>
      {
        G.isNilOrEmpty(panel) &&
        <EmptyList width='100%'>
          {G.getWindowLocale('titles:empty-list', 'Empty List')}
        </EmptyList>
      }
      {
        G.isNotNilAndNotEmpty(panel) &&
        panel.map((statusActionsObject, i) => {
          const statusActionsData = isCentralizedDispatchActions
            ? R.mergeRight(statusActionsObject, {
              [GC.FIELD_CONFIGURATION_UI_DISPATCH_BOARD_ACTIONS_FIRST_ROW]: R.prop(
                GC.FIELD_CONFIGURATION_UI_CENTRALIZED_DISPATCH_ACTIONS,
                statusActionsObject,
              ),
              [GC.FIELD_CONFIGURATION_UI_DISPATCH_BOARD_ACTIONS_SECOND_ROW]: [],
            })
            : statusActionsObject;

          return (
            <Flex key={i} height={G.ifElse(isCentralizedDispatchActions, 35, 55)} alignItems='stretch'>
              <ConfigGroupLeftSectionWrapper>
                {G.getWindowLocale(GC.statusLocaleMap[statusActionsObject.status], statusActionsObject.status)}
              </ConfigGroupLeftSectionWrapper>
              <Flex
                flexGrow='1'
                p='0px 15px'
                borderBottom='1px solid'
                justifyContent='space-between'
                borderColor={G.getTheme('colors.bgGrey')}
              >
                <Flex>
                  {
                    R.not(isCentralizedDispatchActions) &&
                    <Flex fontSize={12} alignItems='stretch' flexDirection='column'>
                      <Flex mb='8px' mr={16} height={20}>
                        {G.getWindowLocale('titles:first-row', 'First Row')}:
                      </Flex>
                      <Flex mr={16} height={20}>
                        {G.getWindowLocale('titles:second-row', 'Second Row')}:
                      </Flex>
                    </Flex>
                  }
                  <LoadStatusActions loadType={loadType} data={statusActionsData} withoutActions={true} />
                </Flex>
                <Flex>
                  <Box
                    ml='8px'
                    cursor='pointer'
                    onClick={() => handleEditEntity(statusActionsObject, loadType, configNameToUse)}
                  >
                    {I.renderEditIcon(iconColor)}
                  </Box>
                  <Box
                    ml='8px'
                    cursor='pointer'
                    onClick={() => deleteDispatchBoardStatusActionRequest({
                      loadType,
                      configName: configNameToUse,
                      guid: statusActionsObject[GC.FIELD_GUID],
                    })}
                  >
                    {I.trash(iconColor)}
                  </Box>
                </Flex>
              </Flex>
            </Flex>
          );
        })
      }
    </Box>
  );
};

export default DispatchPanelConfig;
